import { CompositeView, GridView, SimpleView } from '@digital/ui';
import React from 'react';
import WidgetSolicitacoes from './WidgetSolicitacoes';

interface ListaSolicitacaoProps {
}

const ListaSolicitacao = ({ }: ListaSolicitacaoProps) => {
    return (
        <SimpleView>
            <GridView>
                <CompositeView>
                    <WidgetSolicitacoes />
                </CompositeView>
            </GridView>
        </SimpleView>
    );
};

export default ListaSolicitacao;
